export default __webpack_public_path__ + "static/media/231122_Nomady_DigitalFormats_AppWelcome4.55f19cff.webp";